import Vue from 'vue'

export default Vue.extend({
  mounted () {
    this.$store.direct.dispatch.opsmonitor.subscribeSocialMediaMonitor()
  },
  beforeDestroy () {
    this.$store.direct.dispatch.opsmonitor.unsubscribeSocialMediaMonitor()
  }
})